import strings from '../../../locale/en'
import { AnsweredTestResult, Question } from '../../../redux/test/type'

const determineOptions = (
  answeredTestResult: AnsweredTestResult,
  questions: Array<Question>
) => {
  const questionsIndexList = Array.from(
    new Array(answeredTestResult?.totalQuestions),
    (x, i) => i + 1
  )

  const yourTimeSpentList = questions.map((question) =>
    Number(question.timeSpent)
  )

  const toppersTimeSpentList = questions.map((question) =>
    Number(question.timeSpentByTopper)
  )

  return {
    title: {
      text: ' '
    },
    xAxis: {
      categories: questionsIndexList,
      title: {
        text: strings.test.questionNumbers
      }
    },
    yAxis: {
      title: {
        text: strings.test.timeInSeconds
      }
    },
    series: [
      {
        name: strings.test.timeTakenByYou,
        color: '#EAD10A',
        lineWidth: 2,
        data: yourTimeSpentList
      },
      {
        name: strings.test.timeTakenByTopper,
        color: '#7B5DC6',
        lineWidth: 2,
        data: toppersTimeSpentList
      }
    ]
  }
}

export default determineOptions
